import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { Badge } from '../types/tombola';
interface BadgeGridProps {
  badges: Badge[];
}
export function BadgeGrid({
  badges
}: BadgeGridProps) {
  const [selectedBadge, setSelectedBadge] = useState<Badge | null>(null);
  return <>
      <div className="grid grid-cols-4 gap-3" data-id="element-15">
        {badges.map(badge => <button key={badge.id} onClick={() => setSelectedBadge(badge)} className={`aspect-square rounded-2xl flex flex-col items-center justify-center p-3 transition-all duration-200 ${badge.unlocked ? 'bg-gradient-to-br from-amber-100 to-orange-100 shadow-sm hover:shadow-md hover:scale-105' : 'bg-gray-100'}`} style={{
        filter: badge.unlocked ? 'none' : 'grayscale(100%) opacity(0.5)'
      }} data-id="element-16">
            <span className="text-3xl mb-1" data-id="element-17">{badge.icon}</span>
            <span className="text-xs text-gray-700 text-center font-medium line-clamp-2" data-id="element-18">
              {badge.name}
            </span>
          </button>)}
      </div>
      {selectedBadge && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" onClick={() => setSelectedBadge(null)} data-id="element-19">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-xl" onClick={e => e.stopPropagation()} data-id="element-20">
            <div className="flex justify-between items-start mb-4" data-id="element-21">
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center text-4xl ${selectedBadge.unlocked ? 'bg-gradient-to-br from-amber-100 to-orange-100' : 'bg-gray-100'}`} style={{
            filter: selectedBadge.unlocked ? 'none' : 'grayscale(100%) opacity(0.5)'
          }} data-id="element-22">
                {selectedBadge.icon}
              </div>
              <button onClick={() => setSelectedBadge(null)} className="text-gray-400 hover:text-gray-600" data-id="element-23">
                <XIcon className="w-6 h-6" data-id="element-24" />
              </button>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-25">
              {selectedBadge.name}
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-26">{selectedBadge.description}</p>
            {selectedBadge.unlocked ? <div className="bg-green-50 border border-green-200 rounded-xl p-3" data-id="element-27">
                <p className="text-sm text-green-700 font-medium" data-id="element-28">
                  ✓ Débloqué le{' '}
                  {selectedBadge.unlockedAt?.toLocaleDateString('fr-FR')}
                </p>
              </div> : <div className="bg-gray-50 border border-gray-200 rounded-xl p-3" data-id="element-29">
                <p className="text-sm text-gray-600" data-id="element-30">🔒 Pas encore débloqué</p>
              </div>}
          </div>
        </div>}
    </>;
}